function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 70,
    viewBox: "0 0 73 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: " drawsvg-initialized ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.157 43.2689C27.0827 43.2689 29.4546 40.8971 29.4546 37.9713C29.4546 35.0455 27.0827 32.6737 24.157 32.6737C21.2312 32.6737 18.8594 35.0455 18.8594 37.9713C18.8594 40.8971 21.2312 43.2689 24.157 43.2689Z",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "33.2905, 33.2905",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02415 49.3233C11.9499 49.3233 14.3217 46.9515 14.3217 44.0257C14.3217 41.1 11.9499 38.7281 9.02415 38.7281C6.09837 38.7281 3.72656 41.1 3.72656 44.0257C3.72656 46.9515 6.09837 49.3233 9.02415 49.3233Z",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "33.2904, 33.2904",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3203 69.0001L17.8621 52.4867C18.4524 49.7471 20.3747 48.3697 23.4019 47.8097L32.4835 46.2961L41.4894 38.1681C41.4894 38.1681 44.4712 43.2689 41.1715 46.3869L34.6782 52.8197L24.749 55.8469",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "74.3726, 74.3726",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9414 69L30.9686 53.864",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "15.4358, 15.4358",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2742 47.8097C61.1999 47.8097 63.5717 45.4378 63.5717 42.5121C63.5717 39.5863 61.1999 37.2145 58.2742 37.2145C55.3484 37.2145 52.9766 39.5863 52.9766 42.5121C52.9766 45.4378 55.3484 47.8097 58.2742 47.8097Z",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "33.2903, 33.2903",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0201 69L67.6296 57.2091C67.0393 54.4695 65.3441 52.3656 60.546 52.3656C57.2615 52.3656 42.3828 52.3656 42.3828 52.3656C42.3828 52.3656 43.3969 58.42 48.4372 58.42H60.546",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "61.3176, 61.3176",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8484 69.0001L56.0039 58.4049",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "11.2711, 11.2711",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 69L4.24012 58.5411C4.83043 55.8015 6.75269 54.4241 9.77989 53.8641L17.3479 52.3505",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "26.1766, 26.1766",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1288 6.53394L4.21094 15.4944L11.0978 20.8223L10.1594 29.4044L31.0924 20.4439",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "62.8669, 62.8669",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4777 39.9995L22.707 0.888184",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "42.5553, 42.5553",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.579 52.3505L41.8242 45.6604",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "7.23508, 7.23508",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4646 69.0001L47.0903 58.42",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "11.4487, 11.4487",
      strokeDashoffset: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon);
export default __webpack_public_path__ + "static/media/teamIcon.3f0be8fff8da8d7adc10d3de960973dc.svg";
export { ForwardRef as ReactComponent };